import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.pruefplan-saison-filter';
import * as api from '../../../clients/qschecks';

@Injectable()
export class QschecksPruefplanSaisonFilterEffects {

    PruefplanSaisonFilter$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_PRUEFPLAN_SAISON_FILTER),
        mergeMap((x: ac.GetPruefplanSaisonFilterAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getPruefplanSaisonFilter(x.pruefplan_id).pipe(
                map((result: any) => {
                    return new ac.GetPruefplanSaisonFilterErfolgreichAction(result, x.pruefplan_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetPruefplanSaisonFilterFehlerAction(error, x.pruefplan_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ControllingQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ControllingQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ControllingQueryService);
        }
        return this.service;
    }
}
